<template>
  <div class="row">
    <div class="col-md-12">
      <div class="row form-title d-flex align-items-center mb-4">
        <span class="rounded-circle bg-primary mr-2 d-flex justify-content-center align-items-center text-white">1</span>
        <h2 class="m-0">Project Identification</h2>
      </div>
      <div class="row d-flex justify-content-end align-items-center">
        <span class="red-dot mr-2"></span> = Required
      </div>
      <div class="form-group">
          <label for="timeZone.id">Time Zone</label>
        <select id="timeZone.id" name="timeZone_id" class="custom-select" v-model="project.timeZone.id" :readonly="project.fromBids" :disabled="project.fromBids">
          <option v-for="timeZone in getTimeZones" :key="timeZone.id" :value="timeZone.id">{{ timeZone.name }}</option>
        </select>
      </div>

      <div class="form-group">
        <label for="ocaaNumber">Project Number</label>
        <input id="ocaaNumber" name="ocaaNumber" type="text" class="form-control" placeholder="Number will be auto-generated on save" v-model="project.ocaaNumber" readonly />
      </div>

      <div class="form-group">
        <label for="lcaNumber">LCA Number</label>
        <input id="lcaNumber" name="lcaNumber" type="text" class="form-control" autocomplete="off" placeholder="Enter LCA Number" v-model="project.lcaNumber" />
      </div>

      <div class="form-group" v-if="!project.isPrivate">
        <label for="belongZoneId">
          Belongs To
          <span class="red-dot ml-3" v-if="requiredForPrebid"></span>
        </label>
        <select id="belongZoneId" name="belongZoneId" class="custom-select" :class="{ 'is-invalid': errors.has('belongZoneId') }"
            v-validate="{ required: requiredForPrebid }" v-model="project.belongZoneId" data-vv-as="Belongs To">
          <option v-for="zone in zones" :key="zone.id" :value="zone.id">{{ zone.name }}</option>
        </select>
        <div class="invalid-feedback">The Belongs To field is required</div>
      </div>

      <div v-if="!project.isPrivate">
        <label>Share with Zones</label>
        <div id="shareWithZones">
          <div v-for="(zone, index) in zones" :key="zone.id" class="custom-control custom-checkbox">
            <input :id="'shared-zone-' + index" name="sharedZoneIds" type="checkbox" class="custom-control-input" :value="zone.id" v-model="project.sharedZoneIds">
            <label class="custom-control-label" :for="'shared-zone-' + index">{{ zone.name }}</label>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="title">
          Project Title
          <span class="red-dot ml-3"></span>
        </label>
        <input id="title" name="title" type="text" class="form-control" :class="{ 'is-invalid': errors.has('title') }" autocomplete="off" placeholder="Enter project title"
          v-validate="'required'" v-model="project.title" :readonly="project.fromBids" data-vv-as="Project Title" />
        <div class="invalid-feedback">The Project Title field is required</div>
      </div>

      <div class="form-group">
        <label for="solicitationNumber">Owner Solicitation Number</label>
        <input id="solicitationNumber" name="solicitationNumber" type="text" class="form-control" autocomplete="off" placeholder="Enter Owner Solicitation Number"
          v-model="project.ownerSolicitationNumber" :readonly="project.fromBids" />
      </div>
    </div>
    <div class="col-md d-none d-lg-block"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { isDraftMode, isPreBid, isPrivateProject, requiredForPrebid } from "@/mixins/projectStatuses";

export default {
  name: "ProjectIdentification",
  inject: ["$validator"],
  props: ["project", "zones"],
  mixins: [isDraftMode, isPreBid, isPrivateProject, requiredForPrebid],
  computed: {
    getDefaultTimeZone() {
      return this.project.timeZone.id ? this.project.timeZone : this.getClientTimeZone;
    },
    ...mapGetters(["getZones", "getTimeZones", "getClientTimeZone"])
  },
  mounted () {
    this.project.timeZone = this.project.timeZone.id ? this.project.timeZone : this.getClientTimeZone;
  }
};
</script>
